import { useState } from 'react';
import { Button } from 'subframe/index';
import { AtomicTooltip } from './design-system';

export interface ReloadButtonProps {
  reload: () => Promise<any>;
}

export function ReloadButton(props: ReloadButtonProps): JSX.Element {
  const [loading, setLoading] = useState<boolean>(false);
  return (
    <AtomicTooltip tooltipContent="Reload the current view to get the freshest data">
      <Button
        variant="brand-tertiary"
        size="medium"
        loading={loading}
        icon="FeatherRefreshCw"
        onClick={async () => {
          if (loading) {
            return;
          }

          setLoading(true);
          try {
            await props.reload();
          } finally {
            setLoading(false);
          }
        }}
      />
    </AtomicTooltip>
  );
}
